import {
  ChevronDown,
  CreditCard,
  GraduationCap,
  Headphones,
  LayoutDashboard,
  Layers,
  Lock,
  LogOut,
  Phone,
  Receipt,
  ShieldCheck,
  Tv,
  User,
  Wallet,
  Wifi,
  Zap,
  type LucideIcon,
} from 'lucide-react';
import { cn } from '@/utils/cn';

export type NavIconName =
  | 'overview'
  | 'airtime'
  | 'data'
  | 'bills'
  | 'electricity'
  | 'cable'
  | 'exams'
  | 'services'
  | 'transactions'
  | 'profile'
  | 'security'
  | 'support'
  | 'wallet'
  | 'logout'
  | 'user';

const iconMap: Record<NavIconName, LucideIcon> = {
  overview: LayoutDashboard,
  airtime: Phone,
  data: Wifi,
  bills: Receipt,
  electricity: Zap,
  cable: Tv,
  exams: GraduationCap,
  services: Layers,
  transactions: Receipt,
  profile: User,
  security: Lock,
  support: Headphones,
  wallet: Wallet,
  logout: LogOut,
  user: User,
};

export function NavIcon({
  name,
  className,
  strokeWidth = 2,
}: {
  name: NavIconName;
  className?: string;
  strokeWidth?: number;
}) {
  const Icon = iconMap[name];
  return <Icon className={cn('h-[18px] w-[18px] shrink-0', className)} strokeWidth={strokeWidth} />;
}

export { ChevronDown, ShieldCheck, CreditCard };
